import { lazy } from 'react';
import type { ModuleDefinition } from '@/shared/types/module';

const DashboardPage = lazy(() =>
  import('./DashboardPage').then((m) => ({ default: m.DashboardPage })),
);

export const dashboardModule: ModuleDefinition = {
  id: 'dashboard',
  name: 'Dashboard',
  routes: [
    { path: '/dashboard', element: <DashboardPage />, handle: { layout: 'app', auth: true } },
  ],
  navigation: [],
};
